import { createStore } from 'stimulus-store';

export const deviceTypeFilterSelectionStore = createStore({
    name: 'deviceTypeFilterSelectionStore',
    type: String,
    initialValue: ''
});
